<template>
  <div v-if="configVisible" class="gx-modal" @click.self="configVisible=false">
    <div class="gx-modal-box gx-config-dialog">
      <div class="gx-modal-head" style="background: #ffffff">
        <div class="gx-modal-title">数据配置<span class="gx-config-sub">勾选字段后，下方表格同步显示</span> </div>
        <button class="gx-modal-close" @click="configVisible = false">✕</button>
      </div>
      <div class="gx-modal-body">
        <div v-for="grp in columnGroups" :key="grp.title" class="gx-config-group">
          <div class="gx-config-group-head">
            <span class="gx-config-group-bar" :style="{ background: grp.color }"></span>
            <span class="gx-config-group-title">{{ grp.title }}</span>
            <span class="gx-config-group-all" @click="toggleGroupAll(grp)">
                <span class="gx-config-cb gx-config-cb--lg" :class="{ 'gx-config-cb--on': groupAllChecked(grp)}" :style="{ color: groupAllChecked(grp) || groupIndeterminate(grp) ? grp.color : '#DCDFE6' }">
                  <svg v-if="groupAllChecked(grp)" width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.5l2.5 2.5 4.5-5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  <span v-else-if="groupIndeterminate(grp)" class="gx-config-cb-half-line" :style="{ background: grp.color,borderColor:grp.color }"></span>
                </span>
                <span class="text-gray">全选</span>
              </span>
          </div>
          <div class="gx-config-fields">
              <span
                  v-for="f in grp.fields"
                  :key="f.key"
                  class="gx-config-field"
                  @click="toggleField(f.key)"
                  :style="tempColumnConfig[f.key]?`color:${grp.color};border-color:${grp.color};background:${grp.color+'0f'}`:''"
              >
                <span class="gx-config-cb" :class="{'gx-config-cb--on':tempColumnConfig[f.key]}" :style="{color:tempColumnConfig[f.key] ? grp.color : '#DCDFE6'}">
                  <svg v-if="tempColumnConfig[f.key]" width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.5l2.5 2.5 4.5-5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </span>
                {{ f.label }}
              </span>
          </div>
        </div>
      </div>
      <div class="gx-modal-foot gx-modal-foot--bg" style="background: rgb(238, 241, 246)">
        <button class="gx-modal-foot-btn" @click="resetConfig">重置全选</button>
        <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" @click="confirmConfig">确认</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    currentColumnConfig:{
      type:Object,
      default:()=>{return {}}
    },
    columnGroups:{
      type:Array,
      default:()=>{return []}
    },

  },
  data(){
    return{
      configVisible: false, // 数据配置弹窗
      configFields:[],
      columnConfig: {}, // 字段显隐配置 {key: visible}
      tempColumnConfig: {}, // 弹窗内临时配置
    }
  },
  methods:{
    // 打开数据配置弹窗：将当前配置拷贝给临时配置
    open() {
      this.configFields = this.columnGroups.reduce((arr, g) => arr.concat(g.fields), [])
      this.tempColumnConfig = Object.assign({}, this.currentColumnConfig)
      this.configVisible = true
    },
    // 确认配置：将临时配置应用到正式配置
    confirmConfig() {
      const columnConfig = Object.assign({}, this.tempColumnConfig)
      this.configVisible = false
      this.$emit('change',columnConfig)
    },
    // 重置全选：全部置为显示
    resetConfig() {
      this.configFields.forEach(f => { this.$set(this.tempColumnConfig, f.key, true) })
    },
    // 切换某个字段显隐
    toggleField(key) {
      this.$set(this.tempColumnConfig, key, !this.tempColumnConfig[key])
    },
    // 判断某组是否全部选中
    groupAllChecked(group) {
      return group.fields.every(f => this.tempColumnConfig[f.key])
    },
    // 判断某组是否部分选中（用于半选态）
    groupIndeterminate(group) {
      const checked = group.fields.filter(f => this.tempColumnConfig[f.key]).length
      return checked > 0 && checked < group.fields.length
    },
    // 某组全选/全不选
    toggleGroupAll(group) {
      const allChecked = this.groupAllChecked(group)
      group.fields.forEach(f => { this.$set(this.tempColumnConfig, f.key, !allChecked) })
    }
  }
}

</script>


<style scoped>
.gx-config-dialog{
  width: 560px;
  max-width: 92vw;
  max-height: 86vh;
}
.gx-config-sub{
  font-family: "Noto Sans SC", sans-serif;
  margin-left: 4px;
  font-size: 11px;
  color: #999;
  font-weight: 300;
}
.gx-config-group{
  margin-bottom: 16px;
}
.gx-config-group:last-child{
  margin-bottom: 0;
}
.gx-config-group-head{
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.gx-config-group-bar{
  width: 3px;
  height: 13px;
  border-radius: 2px;
  flex-shrink: 0;
}
.gx-config-group-title{
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-config-group-all{
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #666;
  cursor: pointer;
  user-select: none;
}
.gx-config-fields{
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-config-field{
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 5px;
  border: 1px solid rgb(224, 224, 236);
  background: rgb(255, 255, 255);
  cursor: pointer;
  transition: 0.15s;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
  white-space: nowrap;
}
.gx-config-cb{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border-radius: 3px;
  border: 1px solid #DCDFE6;
  background: transparent;
  flex-shrink: 0;
  transition: all .15s;
  box-sizing: border-box;
}
.gx-config-cb--lg{
  width: 15px;
  height: 15px;
}
.gx-config-cb--on{
  border-color: currentColor;
  background: currentColor;
}
.gx-config-cb-half-line{
  width: 7px;
  height: 1.5px;
  border-radius: 1px;
}

</style>
